import React, { Fragment } from 'react'

import { getMixedProps, genNewList } from './blockPublic'

const VirtualGroup = ({ field, field: { _fieldsetName }, /* onChange,  */initValues, changedValues, defaultStyle, that, renderField }) => {
	const {
		props,
		rest: { name, _virtualGroup, forceDisabled, list: groupList, items, default: _default = {}, ...restGroup }
	} = getMixedProps('_virtualGroup', [defaultStyle, field])

	restGroup.disabled = props.disabled
	delete restGroup.value

	return <Fragment>
		{items && items.map(({ list, ...item }, index) => renderField({
			field: { ...item, _fieldsetName, ...(forceDisabled ? { disabled: true } : {}), list: genNewList(list, groupList) },
			defaultStyle: { ...defaultStyle, ...restGroup, ..._default, forceDisabled/* maxWidth: 'calc(100% - 40px)' */ },
			initValues, changedValues, index, data: that
		})) || null}
	</Fragment>
}

const renderVirtualGroup = config => {
	const { key } = config.field || {}
	return <VirtualGroup key={key} {...config} />
}

export default renderVirtualGroup